import React, { useState,useEffect } from "react";
import PropTypes from "prop-types";

import Header from "../layouts/Header";
import Sidebar from "../layouts/Sidebar"
import BasicInfoEmployer from './formEmployer/BasicInfoEmployer';
import CollectedFdwEmployer from "./formEmployer/CollectedFdwEmployer";
import { useTranslation } from "react-i18next";

// Add custom styles for animations
const tabStyles = `
  @keyframes fadeIn {
    from {
      opacity: 0;
      transform: translateY(10px);
    }
    to {
      opacity: 1;
      transform: translateY(0);
    }
  }
  
  /* Mobile responsive tabs */
  @media (max-width: 768px) {
    .tab-mobile-text {
      display: none;
    }
    .tab-mobile-short {
      display: inline;
    }
    .nav-link {
      padding: 0.75rem 0.5rem !important;
      font-size: 12px !important;
    }
  }
  
  @media (min-width: 769px) {
    .tab-mobile-text {
      display: inline;
    }
    .tab-mobile-short {
      display: none;
    }
  }
`;

const EmployerDetails = () => {

  const {t} = useTranslation();

  const [menu, setMenu] = useState(false);
  const [show, setShow] = useState(false);

  const [activeTab, setActiveTab] = useState("basic");


  
  

  const toggleMobileMenu = () => {
    setMenu(!menu);
  };

  
  return (
    <>
      <style>{tabStyles}</style>
      <div className={`main-wrapper ${menu ? "slide-nav" : ""}`}>
        <Header onMenuClick={() => toggleMobileMenu()} />
        <Sidebar />

        <div className="page-wrapper">
          
              <div className="content container-fluid">
                {/* Page Header */}
                <div className="page-header">
                  <div className="content-page-header d-flex justify-content-between">
                    <h5>{t("Employer Details")}</h5>
                  
                  </div>
                </div>

                {/* Tabs Navigation */}
                <div className="card shadow-sm">
                  <div className="card-header p-4" style={{ backgroundColor: '#f8f9fa', borderBottom: '2px solid #e9ecef' }}>
                    <ul className="nav nav-tabs card-header-tabs mb-0" role="tablist" style={{ border: 'none' }}>
                      <li className="nav-item">
                        <button
                          className={`nav-link px-4 py-3 fw-semibold position-relative ${activeTab === "basic" ? "active" : ""}`}
                          onClick={() => setActiveTab("basic")}
                          type="button"
                          style={{
                            border: 'none',
                            borderRadius: '8px 8px 0 0',
                            backgroundColor: activeTab === "basic" ? '#007bff' : 'transparent',
                            color: activeTab === "basic" ? '#ffffff' : '#6c757d',
                            fontSize: '14px',
                            fontWeight: '600',
                            transition: 'all 0.3s ease',
                            marginRight: '2px',
                            boxShadow: activeTab === "basic" ? '0 -2px 8px rgba(0,123,255,0.2)' : 'none'
                          }}
                          onMouseEnter={(e) => {
                            if (activeTab !== "basic") {
                              e.target.style.backgroundColor = '#e9ecef';
                              e.target.style.color = '#495057';
                            }
                          }}
                          onMouseLeave={(e) => {
                            if (activeTab !== "basic") {
                              e.target.style.backgroundColor = 'transparent';
                              e.target.style.color = '#6c757d';
                            }
                          }}
                        >
                          <i className="fas fa-user me-2"></i>
                          <span className="tab-mobile-text">{t("Basic Details Employer")}</span>
                          <span className="tab-mobile-short">{t("Basic")}</span>
                          {activeTab === "basic" && (
                            <span 
                              className="position-absolute" 
                              style={{
                                bottom: '-2px',
                                left: '50%',
                                transform: 'translateX(-50%)',
                                width: '60%',
                                height: '3px',
                                backgroundColor: '#ffffff',
                                borderRadius: '2px'
                              }}
                            ></span>
                          )}
                        </button>
                      </li>
                      <li className="nav-item">
                        <button
                          className={`nav-link px-4 py-3 fw-semibold position-relative ${activeTab === "collected" ? "active" : ""}`}
                          onClick={() => setActiveTab("collected")}
                          type="button"
                          style={{
                            border: 'none',
                            borderRadius: '8px 8px 0 0',
                            backgroundColor: activeTab === "collected" ? '#28a745' : 'transparent',
                            color: activeTab === "collected" ? '#ffffff' : '#6c757d',
                            fontSize: '14px',
                            fontWeight: '600',
                            transition: 'all 0.3s ease',
                            marginLeft: '2px',
                            boxShadow: activeTab === "collected" ? '0 -2px 8px rgba(40,167,69,0.2)' : 'none'
                          }}
                          onMouseEnter={(e) => {
                            if (activeTab !== "collected") {
                              e.target.style.backgroundColor = '#e9ecef';
                              e.target.style.color = '#495057';
                            }
                          }}
                          onMouseLeave={(e) => {
                            if (activeTab !== "collected") {
                              e.target.style.backgroundColor = 'transparent';
                              e.target.style.color = '#6c757d';
                            }
                          }}
                        >
                          <i className="fas fa-clipboard-list me-2"></i>
                          <span className="tab-mobile-text">{t("Collected Information")}</span>
                          <span className="tab-mobile-short">{t("Collected")}</span>
                          {activeTab === "collected" && (
                            <span 
                              className="position-absolute" 
                              style={{
                                bottom: '-2px',
                                left: '50%',
                                transform: 'translateX(-50%)',
                                width: '60%',
                                height: '3px',
                                backgroundColor: '#ffffff',
                                borderRadius: '2px'
                              }}
                            ></span>
                          )}
                        </button>
                      </li>
                    </ul>
                  </div>

                  <div className="card-body p-4 employer-det-body-card">
                    {/* Tab Content */}
                    {activeTab === "basic" && (
                      <div className="tab-pane fade show active" style={{ animation: 'fadeIn 0.3s ease-in-out' }}>
                        {/* Basic Details Content */}
                        <BasicInfoEmployer/>
                      </div>
                    )}

                    {activeTab === "collected" && (
                      <div className="tab-pane fade show active" style={{ animation: 'fadeIn 0.3s ease-in-out' }}>
                        {/* Collected Information Content */}
                        <CollectedFdwEmployer />
                      </div>
                    )}
                  </div>
                </div>
              </div>
            
        </div>
      </div>

    </>

        
  );
}

EmployerDetails.propTypes = {
  user: PropTypes.shape({
      company: PropTypes.string,
      name: PropTypes.string,
      email: PropTypes.string,
  }).isRequired,
};

export default EmployerDetails;      